import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import App from './App';

const theme = createTheme({
    palette: {
        primary: {
            main: '#1d4e89',
        },
        secondary: {
            main: '#ff8c42',
        },
    },
    typography: {
        fontSize: 16,
        fontFamily: [
            '"Noto Sans JP"',
            '"Hiragino Kaku Gothic ProN"',
            '"Yu Gothic UI"',
            'sans-serif',
        ].join(','),
        h4: {
            fontFamily: ['"M PLUS Rounded 1c"', '"Noto Sans JP"', 'sans-serif'].join(','),
            fontWeight: 700,
            lineHeight: 1.35,
        },
        h6: {
            fontWeight: 700,
        },
        subtitle1: {
            fontSize: '1.05rem',
            lineHeight: 1.6,
        },
        body1: {
            fontSize: '1.02rem',
            lineHeight: 1.7,
        },
        body2: {
            fontSize: '0.96rem',
            lineHeight: 1.6,
        },
        button: {
            fontSize: '0.98rem',
            fontWeight: 700,
        },
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    borderRadius: 10,
                    paddingTop: 10,
                    paddingBottom: 10,
                },
            },
        },
        MuiTab: {
            styleOverrides: {
                root: {
                    minHeight: 54,
                    fontSize: '1rem',
                    fontWeight: 700,
                },
            },
        },
        MuiInputBase: {
            styleOverrides: {
                root: {
                    fontSize: '1rem',
                },
            },
        },
        MuiFormLabel: {
            styleOverrides: {
                root: {
                    fontSize: '0.98rem',
                },
            },
        },
        MuiChip: {
            styleOverrides: {
                root: {
                    fontSize: '0.92rem',
                },
            },
        },
        MuiTypography: {
            defaultProps: {
                variantMapping: {
                    body1: 'p',
                    body2: 'p',
                },
            },
        },
    },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    // React.StrictMode を一時的に無効化 (react-beautiful-dnd の互換性問題のため)
    // <React.StrictMode>
        <BrowserRouter>
            <ThemeProvider theme={theme}>
                <CssBaseline />
                <App />
            </ThemeProvider>
        </BrowserRouter>
    // </React.StrictMode>
); 
